document.addEventListener('DOMContentLoaded', function () {
    const sliderSwiperIngredients = new Swiper(".product-showcase .swiper-container", {
      direction: 'horizontal',
      loop: false,
      pagination: {
        el: ".product-showcase .swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".product-showcase .swiper-button-next",
        prevEl: ".product-showcase .swiper-button-prev",
      },
      slidesPerView: 2,
      centeredSlides: true,
      breakpoints: {
        750: {
            slidesPerView: 4,
            centeredSlides: false,
        },
    },
    
    });
  });
   